









import {Vue, Component, Prop} from 'vue-property-decorator'
import {DateTime} from 'luxon';
import {monthName} from "../../common/dateTimeHelper";
import { TimeTooltipDirective } from '../directives/Tooltip';

@Component({
    directives: { TimeTooltipDirective }
})
export default class DateTimeView extends Vue {
    @Prop({required: true}) from: DateTime;
    @Prop({required: true}) to: DateTime;

    get lang() {
        return this.$store.state.session.language
    }

    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    get offsetNames() {
        return this.$store.state.timeZoneNames || {};
    }

    get tooltipProps() {
        return {
            start: this.from,
            end: this.to,
            lang: this.lang,
            offset: this.offset,
            offsetNames: this.offsetNames
        }
    }

    get formattedDateTime(): string {
        if (this.from && this.to) {
            const month: string = monthName(this.from.month, this.lang);
            return this.from.toFormat('d') + ' ' + month + ', ' +
                this.from.toFormat('HH:mm') + '-' + this.to.toFormat('HH:mm')
        }
        return '';
    }
}
